/* tslint:disable */

/**
 */
export class Color {
    ID_COLOR?: number;
    COLOR_ORDER?: number;
    COLOR_NAME?: string;
    CODE_HEXA?: string;
    COLOR_TEXT?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/color.ts